var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../customers/belfort/widget-planner-conf/node_modules/@mecatran-projects/widget-planner/src/nunjucks-extensions/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("A:/dev/workspace-node/bitbucket_repository/projects/customers/belfort/widget-planner-conf/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["../../../widget-planner/src/templates/macros.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "\r\n\r\n";
var macro_t_1 = runtime.makeMacro(
["href", "title"], 
[], 
function (l_href, l_title, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("href", l_href);
frame.set("title", l_title);
var t_2 = "";t_2 += "\r\n    <div class=\"block-header block-header1\">\r\n        <!--a class=\"block-title\" href=\"";
t_2 += runtime.suppressValue(l_href, env.opts.autoescape);
t_2 += "\">";
t_2 += runtime.suppressValue(env.getFilter("upper").call(context, l_title), env.opts.autoescape);
t_2 += "</a-->\r\n    </div>\r\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("displayBlockHeader1");
context.setVariable("displayBlockHeader1", macro_t_1);
output += "\r\n\r\n\r\n\r\n";
var macro_t_3 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_4 = "";t_4 += "\r\n\r\n";
;
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("displayBlockDirections");
context.setVariable("displayBlockDirections", macro_t_3);
output += "\r\n\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["../../../widget-planner/src/templates/macros.njk"] , dependencies)